export default __webpack_public_path__ + "static/media/sb-ICO-05.712a0e4d.webp";